module.exports = __webpack_public_path__ + "img/magnetism-wire.8594f2b4.png";